module.exports = __webpack_public_path__ + "static/media/SleepHealthHygiene.6b89c0b2.png";